//prettier-ignore

export default {
  translations: {
    "Initialization": "Initialisation…",

    //--------------------

    // Page Login
    "_LOGIN_INDEX_TITLE": "Gérer vos rendez-vous et vos activations",
    "_LOGIN_INDEX_INTRODUCTION": "Ce portail vous permet d’accéder à vos rendez-vous et d’activer votre nouvelle TV Box.",
    "_LOGIN_INDEX_MAIN_DESCRIPTION": "Pour vous connecter, utilisez le code personnel reçu dans le mail de confirmation de votre commande. Attention, vous devez avoir réceptionné votre TV Box avant de pouvoir l’activer.",
    "_LOGIN_INDEX_DESIRED_ACTION": "Quelle action souhaitez-vous effectuer ?",
    "_LOGIN_INDEX_ACTION_MODIFY_APPOINTMENT": "modifier un rendez-vous",
    "_LOGIN_INDEX_ACTION_ACTIVATE_STB": "activer ma TV Box",
    "_LOGIN_INDEX_PERSONAL_CODE": "Saisissez les 8 caractères de votre code personnel",
    "_LOGIN_INDEX_LOGIN_BUTTON": "Se connecter",
    "_LOGIN_INDEX_RESET_CODE_LINK": "Vous ne retrouvez pas votre code personnel ? ",
    //// Hey translation
    "_HEY_LOGIN_INDEX_TITLE": "Replanifie ton rendez-vous avec notre technicien",
    "_HEY_LOGIN_INDEX_INTRODUCTION": "Ce portail te permet de modifier un rendez-vous",
    "_HEY_LOGIN_INDEX_MAIN_DESCRIPTION": "Tu as sûrement reçu un sms et/ou un mail qui comprend ton code à 8 caractères à saisir ici",
    "_HEY_LOGIN_INDEX_INPUT_PLACEHOLDER": "Ton code perso...",
    "_HEY_LOGIN_INDEX_LOGIN_BUTTON": "Go!",
    "_HEY_LOGIN_INDEX_RESET_CODE_LINK": "Code introuvable ? Ca se passe ici.",

    // Page Login WS Errors
    "_LOGIN_INDEX_ERROR_REQUIRED_ACTION": "Veuillez choisir l'action à effectuer",
    "_LOGIN_INDEX_ERROR_REQUIRED_LOGIN": "Veuillez remplir votre code personnel pour vous identifier",
    "_LOGIN_INDEX_ERROR_INCORRECT_LENGTH_LOGIN": "Le code est trop long. Saisissez les 8 caractères de votre code personnel.",
    "_LOGIN_INDEX_ERROR_OCCURRED": "Désolé, un problème est survenu.",
    "_LOGIN_INDEX_ERROR_RESET_CODE_LINK": "Demandez un nouveau code personnel",
    "_LOGIN_INDEX_ERROR_CALLING_NUMBER": "ou appelez le 5000.",
    //// Hey translation
    "_HEY_LOGIN_INDEX_ERROR_REQUIRED_LOGIN": "Tu as oublié de saisir le code !",
    "_HEY_LOGIN_INDEX_ERROR_INCORRECT_LENGTH_TOO_SHORT_LOGIN": "Le code est trop court. Saisis les 8 caractères de ton code personnel.",
    "_HEY_LOGIN_INDEX_ERROR_INCORRECT_LENGTH_TOO_LONG_LOGIN": "Le code est trop long. Saisis les 8 caractères de ton code personnel.",
    "_HEY_LOGIN_INDEX_ERROR_OCCURRED": "Désolé, un problème est apparu.",
    "_HEY_LOGIN_INDEX_ERROR_RESET_CODE_LINK": "Demande un nouveau code.",

    //--------------------

    // Page Reset
    "Resend my WeCareID-code": "Demandez votre code personnel",
    "Please enter your 8-digits customer code over here, and then we will send your WeCareID-code via sms to your mobile.": "Saisissez votre numéro de client et vous recevrez votre code personnel par SMS.",
    "If you are already an existing Orange customer, you can find your customer code on your invoice or in your customer zone.": "Vous êtes déjà client Orange : vous trouverez votre numéro de client en haut à gauche de votre facture ou dans ‘Mon profil' de votre Espace client.",
    "If you are a new Love-customer, you can find your customer code on": "Vous venez juste de commander auprès d'Orange ( vous n'avez pas encore reçu de facture ) : vous trouverez votre numéro de client dans le mail qui confirme votre commande des services internet et TV.",
    "Enter your customer-code to retrieve your WeCareID-code": "Saisissez votre numéro de client",
    "Submit": "Envoyer",
    //// Hey translation
    "_HEY_RESET_TITLE": "Récupère un nouveau code perso",
    "_HEY_RESET_INDICATION_INTRO": "Saisis ton numéro de client hey!, on s'occupe du reste.",
    "_HEY_RESET_INDICATION_OUTRO": "Tu recevras un sms pour récupérer ton nouveau code personnel.",
    "_HEY_RESET_ALREADY_CUSTOMER": "Déjà client hey? Ton numéro de compte client se trouve en haut à gauche de ta facture ou dans l'onglet \"Mon profil\" de My hey!",
    "_HEY_RESET_NEW_CUSTOMER": "Tu viens de commander chez hey! et tu n'as pas de facture ? Ton numéro de client se trouve dans l'e-mail qui confirme ta commande.",
    "_HEY_RESET_INPUT_PLACEHOLDER": "Ton n° de client...",
    "_HEY_RESET_NEW_CODE_BUTTON": "A moi le nouveau code",
    "_HEY_RESET_HOME_LINK": "SMS reçu ? Clique ici",

    // Page Reset WS Success
    "Thanks for submitting your customer code. We received your request. Within 1 minute you should receive an sms with your WeCareID-code.": "Nous avons bien reçu votre demande. Vous recevrez rapidement un SMS avec votre code personnel.",
    "If you didn't receive any sms from us, please verify your customer code and try again or call 5000 for support.": "Si vous n'avez pas reçu de SMS après quelques minutes, saisissez votre numéro de client et essayer de nouveau, ou appelez le 5000.",
    "Please copy the code you received in the sms to identify yourself and change your appointment date": "Appuyez sur le bouton ci-dessous pour continuer lorsque vous avez reçu le SMS.",
    "Change my appointment": "Modifier mon rendez-vous",
    // Page Reset WS Errors
    "Please enter customer code as its required field." :"Saisissez votre numéro de client pour vous identifier",
    "Please enter maximum 9 character long text including dot." :"Le numéro de client n'est pas correct. Essayez de nouveau.",
    "Something went wrong in submitting your customer code. Please try again or call 5000 for support.": "Désolé, un problème est survenu. Demandez de nouveau un code personnel ou appelez le 5000.",
    //// Hey translation
    // positive flow
    "_HEY_RESET_REQUEST_SENT": "Demande bien reçue ! Tu recevras rapidement un sms avec ton code personnel.",
    "_HEY_RESET_SMS_NOT_RECEIVED": "Si tu n'as pas reçu de sms après quelques minutes, saisis ton numéro de client et réessaie.",
    // negative flow
    "_HEY_RESET_CUSTOMER_CODE_NOT_FOUND": "Le numéro de client n'est pas correct. Réessaie.",
    "_HEY_RESET_CUSTOMER_CODE_NOT_FILLED": "Tu as oublié de saisir le numéro de client.",

    //--------------------

    //  Page Appointments
    //"Change my Internet + TV installation date": "Vous devez modifier votre rendez-vous ?",
    "_APPOINTMENT_INDEX_TITLE": "Change my Internet + TV installation date",
    "_APPOINTMENT_WELCOME": "Bonjour",
    "_APPOINTMENT_INFOS_REPLAN_DATE": "Vous trouverez ci-dessous un aperçu de votre/vos rendez-vous prévu(s) pour vos services Orange. Vous pouvez opter pour une autre date en fonction des possibilités des techniciens Orange.",
    "Intervention in past, or status Done or status Cancel - not possible to change": "Rendez-vous annulé ou rendez-vous déjà passé. Ne peut pas être modifié.",
    "_OBE_APPOINTMENT_ADD_INFO_CANCEL": "Rendez-vous annulé ou rendez-vous déjà passé. Si vous voulez prendre un nouveau rendez-vous, appelez-nous au numéro 5000.",
    "Modify": "Modifier",
    "OBE_FIRST_TLN_NONE": "Installation de l'internet et de la TV", //a
    "OBE_FIRST_TLN_STREET": "Installation de l'internet et de la TV", //b
    "OBE_FIRST_VOO_SINGLE": "Installation de l'internet et de la TV", //c
    "OBE_FIRST_TLN_INDOOR_TAP": "Installation de l'internet et de la TV", //d
    "OBE_FIRST_VOO_DUAL": "Installation de l'internet et de la TV", //e
    "TLN_FIRST_INDOOR_TAP": "Vérification de la qualité du câble", //f
    "VOO_FIRST_VOO_DUAL": "Vérification de la qualité du câble", // g
    "OBE_INTERVENTION": "Installation additionnelle", // h
    "OBE_REPAIR": "Réparation", // i
    "REPAIR_DUO": "Réparation", // j
    "REPAIR_VOO": "Réparation", // k
    "REPAIR_TLN": "Réparation", // l
    "INSTALL_DYI": "Installation par le client", // m
    "MODEM_UPGRADE": "Remplacement du modem", // n
    "OBE_INTERVENTION_INTERNET": "Installation additionnelle",
    "OBE_FIRST_INTERNET": "Installation de l'internet",
    "OBE_FTTH_FIRST": "Installation Fibre",
    "OBE_FTTH_INTERVENTION": "Installation additionnelle",
    "OBE_FTTH_REPAIR": "Réparation",
    "OBE_MOVE_INTERNET": "Déménagement",
    "OBE_MOVE_TLN_NONE": "Déménagement",
    "OBE_MOVE_TLN_STREET": "Déménagement",
    "OBE_MOVE_VOO_SINGLE": "Déménagement",
    "OBE_MOVE_TLN_INDOOR_TAP": "Déménagement",
    "OBE_MOVE_VOO_DUAL": "Déménagement",
    "Appointment": "Rendez-vous",
    "Planned date": "Date planifiée",
    "Additional information": "Information additionnelle",
    "_OBE_APPOINTMENT_ADD_INFO_DONE": "Rendez-vous annulé ou rendez-vous déjà passé. Ne peut pas être modifié.",
    "_OBE_APPOINTMENT_ADD_INFO_PENDING_OR_LOCKED": "Malheureusement, vous ne pouvez pas modifier ce rendez-vous vous-même. Merci d'appeler le Service client au numéro 5000.",
    //// Hey translation
    "_HEY_APPOINTMENT_INDEX_TITLE": "Change la date de ton installation internet",
    "_HEY_APPOINTMENT_INFOS_RETRIEVE_DATE": "Retrouve ici ton rendez-vous prévu pour ton service internet.",
    "_HEY_APPOINTMENT_INFOS_REPLAN_DATE": "Tu peux le replanifier en fonction des possibilités des techniciens.",
    "_HEY_APPOINTMENT_ADD_INFO_PENDING_OR_LOCKED": "Malheureusement, tu ne peux pas modifier ce rendez-vous toi-même. Contacte-nous via notre chatbot sur notre site internet www.heytelecom.be/fr.",
    "_HEY_APPOINTMENT_ADD_INFO_DONE": "Rendez-vous annulé ou rendez-vous déjà passé. Ne peut pas être modifié.",
    "_HEY_APPOINTMENT_ADD_INFO_CANCEL": "Rendez-vous annulé ou rendez-vous déjà passé. Souhaites-tu un nouveau rendez-vous? Alors contacte-nous via notre chatbot sur notre site internet www.heytelecom.be/fr",

    // Modal Appointment
    "_APPOINTMENT_MODAL_CHANGE_DATE": "Modifier le rendez-vous",
    "_APPOINTMENT_MODAL_PICK_A_DATE": "Sélectionnez une date",
    "An error occurred. Please call 5000 for support.": "Une erreur est survenue. Veuillez appeler le 5000 pour obtenir de l'aide.",
    //// Hey translation
    "_HEY_APPOINTMENT_MODAL_CHANGE_DATE": "Modifie ton rendez-vous",
    "_HEY_APPOINTMENT_MODAL_PICK_A_DATE": "Sélectionne une date",
    "_HEY_APPOINTMENT_MODAL_SUBMIT_BUTTON": "Je change mon rendez-vous",

    "January": "Janvier",
    "February": "Février",
    "March": "Mars",
    "April": "Avril",
    "May": "Mai",
    "June": "Juin",
    "July": "Juillet",
    "August": "Aout",
    "September": "Septembre",
    "October": "Octobre",
    "November": "Novembre",
    "December": "Décembre",

    "Mo": "lun.",
    "Tu": "mar.",
    "We": "mer.",
    "Th": "jeu.",
    "Fr": "ven.",
    "Sa": "sam.",
    "Su": "dim.",

    "Monday": "Lundi",
    "Tuesday": "Mardi",
    "Wednesday": "Mercredi",
    "Thursday": "Jeudi",
    "Friday": "Vendredi",
    "Saturday": "Samedi",
    "Sunday": "Dimanche",

    "_APPOINTMENT_MODAL_SELECT_PREFFERED_TIMING": "Sélectionnez l'horaire",
    "_HEY_APPOINTMENT_MODAL_SELECT_PREFFERED_TIMING": "Sélectionne l'horaire",

    "8AM" : "(08:00 - 09:00)",
    "AM": "(8:00 - 12:00)",
    "NOON" : "(10:00 - 15:00)",
    "PM": "(13:00 - 18:00)",
    "EVE": "(18:00 - 20:00)",

    "8AM_full" : "8h (08:00 - 09:00)",
    "AM_full": "Matin (8:00 - 12:00)",
    "NOON_full" : "Midi (10:00 - 15:00)",
    "PM_full": "Après-midi (13:00 - 18:00)",
    "EVE_full": "Soir (18:00 - 20:00)",

    "_APPOINTMENT_MODAL_WARNING": "Toute intervention planifiée entre 18h et 20h, ou le samedi engendre un coût supplémentaire de 30 euros. Sauf en cas de réparation sous garantie. Tout rendez-vous non respecté vous sera facturé pour un montant de {{lateCancellationPrice}} € : si vous annulez ou changez le rendez-vous moins d'un jour à l'avance, c'est-à-dire après 12h la veille, ou si vous n'êtes pas présent au rendez-vous.",
    "_HEY_APPOINTMENT_MODAL_WARNING": "Tout rendez-vous non respecté sera facturé {{lateCancellationPrice}} € : si tu annules ou changes le rendez-vous moins d'un jour à l'avance, c'est-à-dire après 12h la veille, ou si tu n'es pas présent au rendez-vous.",

    // "Submit": "Envoyer",
    "_APPOINTMENT_SUBMIT_CHANGE_DATE_TITLE": "Modification du rendez-vous",
    "_APPOINTMENT_SUBMIT_MESSAGE": "Votre rendez-vous a bien été modifié. Fermez la fenêtre pour retourner à l'aperçu.",
    "Something went wrong in submitting the form and changing the date. Please try again.": "Désolé, un problème est survenu. Votre rendez-vous n'a pas été modifié. Veuillez réessayer. Votre rendez-vous n'a pas été modifié. Essayez de nouveau.",
    "Close": "Fermer",
    //// Hey translation
    "_HEY_APPOINTMENT_SUBMIT_CHANGE_DATE_TITLE": "Modification du rendez-vous",
    "_HEY_APPOINTMENT_SUBMIT_MESSAGE": "Ton rendez-vous a bien été modifié. Ferme la fenêtre pour retourner à l'aperçu.",
    "_HEY_APPOINTMENT_SUBMIT_BUTTON_CLOSE": "Fermer la popup",

    // CGN
    "Disabled my CGN": "Désactiver mon CGN",
    "You want to deactivate your CGN": "Vous voulez désactivez votre CGN",
    "How to do": "Comment procéder",
    "Why the CGN": "Pourquoi le CGN",
    "CGN Impact": "Impact du CGN",
    "The CGN at your place.": "Le CGN chez vous.",
    "_cgn_login_why_cgn_txt_p1": "Le CGN (Carrier Grade Nating) est une solution de pallier l'épuisement des adresses IP v4.",
    "_cgn_login_why_cgn_txt_p2": "Cette solution consiste à ne plus attribuer une adresse IP v4 publique à chaque utilisateur résidentiel (Modem), mais à attribuer une adresse IP privée à la place. le système de CGN se charge de faire le lien entre les adresses IP privées attibuées aux utilisateurs et l'adresse publique réellement utilisée pour l'accès internet",
    "_cgn_login_cgn_impact_txt_p1": "Le CGN n’impacte pas de manière perceptible les performances de votre connexion internet.<br />Le CGN est compatible avec la majorité des services Internet.",
    "_cgn_login_cgn_impact_txt_p2": "Les applications, les services requérant l'ouverture de port(s) sont eux impactés.<br />(Par exemple: hébergement de site Web, accès distant à un NAS, hosting de VPN, accès directe (sans cloud) à des objects connectés chez vous, certains jeux/consoles de jeux).",
    "_cgn_login_cgn_how_todo_txt_p1": "La première étape s'est de vous identifier. Munissez vous de votre mail d'installation initiale dans lequel vous trouverez votre code personel. Si vous n'avez pas/plus ce code, pas de soucis,",
    "_cgn_login_cgn_how_todo_txt_p1_end": "pour un obtenir un nouveau.",
    "_cgn_login_cgn_how_todo_txt_p1_link": "ici",
    "The CGN at your place": "Le CGN chez vous",
    "_cgn_form_at_you_place_txt_p1": "Pour modifier ou vérifier le type d'adresse IP que vous avez chez vous, veuillez encoder l'identifiant de votre Modem (aussi appelé HFC MAC address). Cet identifiant se trouve encadré sur l'étiquette sousle Modem. Plus d'info",
    "_cgn_form_at_you_place_txt_p1_link":"ici",
    "_cgn_form_at_you_place_txt_p1_end":".",
    "_cgn_form_input_your_modem_id": "Introduisez l'identifiant de votre modem",
    "_cgn_form_check_your_modem_id_label": "Pour <b>vérifiez</b> le type d'adresse IP (Publique ou Privée/CGN) cliquez sur le bouton ci-dessous:",
    "_cgn_form_ask_ip_public_address_reasons_label": "Pour <b>demander</b> une adresse publique, veuillez sellectionner la/les raisons et ensuite cliquez sur le bouton ci-dessous:",
    "_cgn_form_component_check_ip_label_button": "Vérifier mon type d'adresse IP",
    "_cgn_form_component_update_ip_label_button": "Modifier mon type d'adresse IP",
    "_cgn_ip_policy_cgn": "Le CGN est actif. Vous avez une adresse IPv4 privée.",
    "_cgn_ip_policy_public": "Le CGN est désactivé. Vous avez une adresse IPv4 publique.",
    "_cgn_ip_policy_error": "Oups, nous avons un petit problème technique. Veuillez réessayer plus tard",
    "_cgn_ip_policy_invalid": "Veuillez vérifer l'identifiant de votre modem, semble incorrect",
    "_cgn_update_ip_policy_result_invalid":"Veuillez vérifier l'identifiant de votre modem, il semble incorrect.",
    "_cgn_update_ip_policy_result_error":"Oups, nous avons un petit problème technique.<br />Veuillez nous contacter sur le numéro 5000.",
    "_cgn_update_ip_policy_result_success":"Votre demande de désactivation du CGN a été traitée avec succès, Veuillez redémarrer votre modem pour obtenir votre nouvelle adresse IP",
    "_cgn_update_ip_policy_result_waiting":"Votre demande de désactivation du CGN a bien été prise en compte. Un SMS vous sera envoyé dès que votre demande sera traitée avec succès. (Please refer to the process below mentioned for API NOK scenario",
    //--------------------

    // Page Activations
    "_ACTIVATIONS_INDEX_TITLE": "Activation de votre/vos TV Box",
    "_ACTIVATIONS_INDEX_DESCRIPTION": "Veuillez préciser l’emplacement de votre/vos nouvelles TV Box. Ceci nous permettra de mieux vous guider en cas de problème. " +
      "Vous pouvez identifier chaque TV Box grâce au numéro de série (Serial number 500xxxxxxxxx) mentionné sur l’étiquette en dessous de l’appareil.",
    "_ACTIVATIONS_INDEX_CONFIRM_BUTTON": "Confirm",
    "_ACTIVATIONS_INDEX_ERROR_MISSING_DEVICE_LOCATION": "Veuillez préciser l’emplacement de votre/vos nouvelles TV Box.",

    "_POST_ACTIVATE_CPE_SUCCESS": "L’activation de votre/vos TV Box est terminée. Vous pouvez à présent démarrer la procédure d’installation.",
    "_POST_ACTIVATE_CPE_GENERIC_ERROR": "L’activation de votre/vos TV Box a échoué. Veuillez réessayer plus tard ou contacter le service client.",

    // -------------------

    // User Hardware
    "Desktop": "Bureau",
    "TV room": "Salle TV",
    "Living room": "Salon",
    "Technical room": "Salle technique",
    "Kitchen": "Cuisine",
    "Bedroom": "Chambre",
    "Other": "Autre",
    "Garage street level": "Garage",
    "_HARDWARE_INDEX_SERIAL_NUMBER": "Numéro de série",
    "_HARDWARE_INDEX_DEVICE_LOCATION": "Emplacement",

    //--------------------

    // getPendingCpe errors
    "_GET_PENDING_CPE_ERROR_611": "Nous n’avons pas trouvé de dossier relatif à l’activation d’une TV Box. Pour effectuer une demande, contactez le service client.",
    "_GET_PENDING_CPE_ERROR_612": "Nous n’avons pas trouvé de dossier relatif à l’activation d’une TV Box. Pour effectuer une demande, contactez le service client.",
    "_GET_PENDING_CPE_ERROR_613": "L’activation de votre/vos TV Box a échoué. Veuillez réessayer plus tard ou contacter le service client.",
  },
};



// WEBPACK FOOTER //
// ./src/i18n/fr.js